class Accordion {
    /**
     * @param {Element} accordion
     */
    constructor(accordion) {
        this.accordion = accordion;
        this.init();
    }

    init() {
        this.details = this.accordion.querySelector('.accordion__details');
        this.button = this.accordion.querySelector('.accordion__button');

        if (this.button)
            this.button.addEventListener('click', (e) => this.toggle())
        else
            this.accordion.addEventListener('click', (e) => this.toggle());
    }

    toggle() {
        const detailsHeight = this.details.scrollHeight;

        this.details.style.setProperty('--open-height', detailsHeight + 'px');
        this.accordion.classList.toggle('open');

        this.autoCloseOthers();
    }

    autoCloseOthers() {
        if (this.accordion.hasAttribute("data-accordion-auto-close")) {
            this.accordion.parentElement.querySelectorAll('.accordion').forEach((el) => {
                if (el !== this.accordion) {
                    el.classList.remove('open');
                }
            })
        }
    }
}

class Menu {
    /**
     *
     * @param {Element} menu
     */
    constructor(menu) {
        this.menu = menu;

        this.init();
    }

    init() {
        this.burgerMenu = this.menu.querySelector('.burger-menu');

        if (this.burgerMenu)
            this.burgerMenu.addEventListener('click', (e) => this.toggleMenu())
    }

    toggleMenu() {
        this.menu.style.setProperty('--open-height', `${this.menu.querySelector("nav > .left").scrollHeight + 40}px`);
        this.menu.classList.toggle('open');
    }
}

function initAccordions() {
    document.querySelectorAll('.accordion').forEach(accordion => {
        new Accordion(accordion);
    })

    document.querySelectorAll('.header-menu').forEach(accordion => {
        new Menu(accordion);
    })
}

function init() {
    initAccordions();
}

document.addEventListener('DOMContentLoaded', init)
